import React, { useState } from "react";
import axios from "axios";
import SearchEngine from "./SearchEngine.js";
import DailyForecast from "./DailyForecast";
import "./Styles.css";

export default function Forecast(props) {
  const [city, setCity] = useState(props.city);
  const [forecast, setForecast] = useState({ loading: false });
  function getResponse(response) {
    setForecast({
      loading: true,
      city: response.data.city,
      temperature: Math.round(response.data.temperature.current),
      humidity: Math.round(response.data.temperature.humidity),
      wind: Math.round(response.data.wind.speed),
      condition: response.data.condition.description,
      icon: response.data.condition.icon_url,
      dayTime: new Date(response.data.time * 1000),
    });
  }

  function search() {
    const apiKey = "86d11b15bf79a84309ce4be6o80tad43";
    let url = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=imperial`;
    axios.get(url).then(getResponse);
  }

  function submitData(event) {
    event.preventDefault();
    search();
  }

  function searchCity(event) {
    setCity(event.target.value);
  }

  if (forecast.loading) {
    return (
      <div className="Forecast">
        <form onSubmit={submitData}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="Enter city.."
                className="search-forecast w-100"
                autoFocus="on"
                onChange={searchCity}
              />
            </div>
            <div className="col-3">
              <input type="submit" value="Search" className="btn w-100" />
            </div>
          </div>
        </form>
        <SearchEngine info={forecast} />
        <DailyForecast info={forecast} />
      </div>
    );
  } else {
    search();
    return "Loading, please hold";
  }
}
